module.exports = __webpack_public_path__ + "static/media/char_vic_v2.f2bdc132.jpg";